import { Modal } from "antd";
import React from "react";
import FileUpload from "./FileUpload";
import toast from 'react-hot-toast';
const UploadFileModal = ({
  isFileUploadModalOpen,
  setIsFileUploadModalOpen,
}) => {
  const handleFileUpload = async (file, fileContent) => {
    if (!file) {
      toast.error("No file selected!");
      // throw new Error("No file provided");
    }
    return new Promise((resolve) => {
      console.log("File name:", file.name);
      // console.log("File content:", fileContent);

      const totalSize = file.size;
      let uploaded = 0;

      const interval = setInterval(() => {
        uploaded += totalSize * 0.1; // Simulate 10% upload per step
        if (uploaded >= totalSize) {
          clearInterval(interval);
          resolve();
          toast.success("File uploaded successfully");
          setIsFileUploadModalOpen(false);
        }
      }, 150); // Simulate upload progress every 300ms
    });
  };
  const handleOk = () => {
    setIsFileUploadModalOpen(false);
  };

  const handleCancel = () => {
    setIsFileUploadModalOpen(false);
  };
  return (
    <Modal
      footer={false}
      title="Upload File"
      open={isFileUploadModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <div className="p-6">
        <h1 className="text-lg font-bold mb-4">Drag & Drop File Upload</h1>
        <FileUpload onFileUpload={handleFileUpload} />
      </div>
    </Modal>
  );
};

export default UploadFileModal;
